import { UseQueryResult, useQuery } from "@tanstack/react-query"
import usePrivateAxios from "@/common/api/usePrivateAxios"
import type { CompanyEventGroupedFee } from "../types/companyEventGroupedFee.type"

export const useCompanyGroupedFee: (id: string) => UseQueryResult<CompanyEventGroupedFee[], unknown> = (id) => {
  const privateAxios = usePrivateAxios()
  return useQuery<{ data: { data: CompanyEventGroupedFee[] } }, unknown, CompanyEventGroupedFee[]>({
    queryKey: ['companyGroupedFee', id],
    queryFn: () => privateAxios.get(`/billing/events/${id}/fees`),
    enabled: !!id,
    select: response => response.data.data
  })
}
